import { useState, useEffect } from 'react';

import EtrAPIClient from '../core/src/etr-wcs-api-client';

export default product => {
    const [productData, setProductData] = useState({});
    const { productUrl, linkUrl, sku } = product || {};
    useEffect(() => {
        const [dir, slug] = (productUrl || linkUrl || '').split('pdp/');
        if (slug && !(sku in productData)) {
            setProductData({ ...productData, [sku]: { fetching: true } });
            EtrAPIClient.component.get('product', 'specs', { path: slug }).then(response => {
                setProductData({ ...productData, [sku]: { specs: response, fetching: false } });
            });
        }
    }, [sku]);

    return productData[sku] || {};
};
